import {Component, ElementRef, HostBinding, Input, SimpleChanges} from "@angular/core";

@Component({
    selector: "fui-columns",
    styleUrls: ["./columns.component.scss"],
    templateUrl: "./columns.component.html",
    standalone: false
})
export class FUIColumnsComponent {
    @HostBinding("class.labelled") @Input() public label: string;
    @HostBinding("class.bordered") @Input() bordered: boolean;
    @Input() i18nParams: any = {};

    private _minColWidth: number = 250;

    constructor(private element: ElementRef) {
    }

    @Input()
    get minColWidth(): number {
        return this._minColWidth;
    }

    set minColWidth(minColWidth: number) {
        this._minColWidth = minColWidth;
        this.element.nativeElement.style.setProperty("--min-col-width", minColWidth);
    }
}
